export const iconFontAwesomeBuildingsSchoolCircleExclamation = (
	<i className="fa-solid fa-school-circle-exclamation"></i>
);
